import MarqueeCarousel from "@/components/organisms/Carousels/MarqueeCarousel";
import { SuccessStoryType } from "@/shared/types/common.types";
import WebinarMarqueeCard from "./WebinarMarqueeCard";
import WebinarMwebCard from "./WebinarMwebCard";


export type WebinarTestimonialPropType = {
  title: string;
    successStoriesSlider1: SuccessStoryType[];
    successStoriesSlider2: SuccessStoryType[];
    // cta?: CtaType;
  };
  
  const WebinarTestimonial = ({
    title,
    successStoriesSlider1,
    successStoriesSlider2,
  }: WebinarTestimonialPropType) => {
    
  
    return (
      <div className="flex flex-col gap-6 sm:gap-8">
        <div className="container flex items-center justify-center">
        <h2 className="mb-6 text-center text-title1 font-semibold">{title}</h2>
          {/* <SectionHeading heading={title} key={"marquee-section" + title} /> */}
          {/* {cta && (
            <div className="hidden sm:block">
              <CtaButtonGroup ctas={[cta]} />
            </div>
          )} */}
        </div>
        <section className="group/marquee-container pointer-events-none relative -my-20 hidden flex-col gap-6 overflow-hidden py-20 sm:flex">
          <div className="absolute bottom-0 left-0 top-0 z-50 hidden h-full w-40  bg-gradient-to-l from-transparent to-white sm:block"></div>
          <div className="absolute right-0 z-50 hidden h-full w-40  bg-gradient-to-r from-transparent to-white sm:block"></div>
          <MarqueeCarousel pauseOnHover>
            {successStoriesSlider1.map((successStory, index) => (
              <WebinarMarqueeCard
                direction="BOTTOM"
                key={index}
                successStory={successStory}
              />
            ))}
          </MarqueeCarousel>
          <MarqueeCarousel pauseOnHover direction="right">
            {successStoriesSlider2.map((successStory, index) => (
              <WebinarMarqueeCard
                direction="TOP"
                key={index}
                successStory={successStory}
              />
            ))}
          </MarqueeCarousel>
        </section>
  
        <section className="group/marquee-container pointer-events-none relative -my-20 flex flex-col gap-6 overflow-hidden py-20 sm:hidden">
          <div className="absolute bottom-0 left-0 top-0 z-50 hidden h-full w-40  bg-gradient-to-l from-transparent to-white sm:block"></div>
          <div className="absolute right-0 z-50 hidden h-full w-40  bg-gradient-to-r from-transparent to-white sm:block"></div>
          <MarqueeCarousel pauseOnHover>
            {[...successStoriesSlider1, ...successStoriesSlider2].map(
              (successStory, index) => (
                <WebinarMwebCard key={index} successStory={successStory} />
              )
            )}
          </MarqueeCarousel>
        </section>
  
        {/* {cta && (
          <div className="container sm:hidden">
            <CtaButtonGroup ctas={[cta]} />
          </div>
        )} */}
      </div>
    );
  };
  
  export default WebinarTestimonial;
  